var _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPageBannerBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 700,
    viewBox: "0 0 700 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 350,
    r: 350,
    fill: "#5A49F8",
    fillOpacity: 0.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 350,
    r: 279,
    fill: "#DDDDDD",
    fillOpacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 350,
    r: 216,
    fill: "#DDDDDD",
    fillOpacity: 0.45
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageBannerBg);
export default __webpack_public_path__ + "static/media/page_banner_bg.2ef0fee7748a0eed5664d03984e89196.svg";
export { ForwardRef as ReactComponent };